const GIL_API_CHANNEL = {
  channel: 'gil',
};

export { GIL_API_CHANNEL };
